export function authHeader(): HeadersInit {
    const applicationType = 'application/json';
    return { 'Content-Type': applicationType };
};
export function authHeaderNoContentType(): HeadersInit {
    return new Headers();
} 
